import { styled } from "goober";
import { Card } from "../Settings/shared";
import { Text } from "../Text";
import { Toggle } from "../Toggle";

const Row = styled("div")`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 8px;
`;

const Info = styled("div")`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

type Props = {
  enabled: boolean;
  disabled: boolean;
  onToggle: () => void;
};

export function AvailabilityCard({ enabled, disabled, onToggle }: Props) {
  return (
    <Card>
      <Row>
        <Info>
          <Text variant="text-regular-md">Available to AI</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            When on, the AI can use this skill.
          </Text>
        </Info>
        <Toggle isOn={enabled} disabled={disabled} onToggle={onToggle} />
      </Row>
    </Card>
  );
}
